import useBranch from "@/shared/atoms/useBranch";
import useOrders from "@/shared/hooks/useOrders";
import useMapOverviewSettingsQuery from "@/shared/queries/mapOrders/useMapOverviewSettingsQuery";
import { asArray } from "@/shared/utils/helpers";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import MapWithCouriers, { MapWithCouriersProps } from "./MapWithCouriers";

export interface MapWithFilter extends MapWithCouriersProps {}

const MapWithFilters = (props: MapWithCouriersProps) => {
  const [branch] = useBranch();
  const { t } = useTranslation("", { keyPrefix: "orders_live" });
  const { t: tCommon } = useTranslation("");

  const {
    data: { selected_order_statuses },
  } = useMapOverviewSettingsQuery();
  const { data } = useOrders();
  const orders = useMemo(
    () =>
      data?.[0]?.filter(
        (order) =>
          order.order_information.delivery_method_id === 1 &&
          asArray(selected_order_statuses).includes(
            order.order_information.order_status
          )
      ) ?? [],
    [data, selected_order_statuses]
  );

  return (
    <>
      <MapWithCouriers {...props} branch={branch} orders={orders} />
    </>
  );
};

export default MapWithFilters;
